import { usePageResize } from '@/utils/hooks/usePageResize';
import { currentSiteName } from '@/utils/tools';

type props = { key: string, value: string; };
const Document: Document = document;

const createElement = (tagName: string, props: Array<props>): HTMLElement => {
  const dom = document.createElement(tagName);
  for (const ele of props) {
    dom.setAttribute(ele.key, ele.value);
  }
  return dom;
};

export const getFavicon = (): Promise<Record<string, any>> => {
  let url: string | null;
  const nodeList = document.getElementsByTagName('link');
  for (let i = 0; i < nodeList.length; i++) {
    if ((nodeList[i].getAttribute('rel') === 'icon') || (nodeList[i].getAttribute('rel') === 'shortcut icon')) {
      url = nodeList[i].getAttribute('href');
    }
  }
  return new Promise((resolve) => {
    const img = new Image();
    img.src = url as string;
    if (img.complete) {
      resolve({ url, width: img.width, height: img.height });
    } else {
      img.onload = () => {
        resolve({ url, width: img.width, height: img.height });
      };
    }
  });
};

export const useHead = () => {
  const sizeStore = usePageResize();
  // const { url: imgUrl, width: imgWidth, height: imgHeight } = await getFavicon();
  const canonical = createElement('link', [{ key: 'rel', value: 'canonical' }, { key: 'href', value: window.location.href }]);
  const OgType = createElement('meta', [{ key: 'property', value: 'og:type' }, { key: 'content', value: 'project' }]);
  const OgTitle = createElement('meta', [{ key: 'property', value: 'og:title' }, { key: 'content', value: `${currentSiteName()} - 全球开发者的开源社区,开源代码托管平台` }]);
  const OgUrl = createElement('meta', [{ key: 'property', value: 'og:url' }, { key: 'content', value: window.location.href }]);
  // const OgImage = createElement('meta', [{ key: 'property', value: 'og:image' }, { key: 'content', value: 'https://gitcode-img.obs.cn-south-1.myhuaweicloud.com/ed/fa/546e1d3890f8a33d24afd63ee371fbb27e63abfde7cf350f06c975aba67afd95.png' }]);
  const ogWidth = createElement('meta', [{ key: 'property', value: 'og:width' }, { key: 'content', value: '49' }]);
  const ogHeight = createElement('meta', [{ key: 'property', value: 'og:height' }, { key: 'content', value: '49' }]);
  // const img = createElement('img', [
  //   { key: 'src', value: 'https://gitcode-img.obs.cn-south-1.myhuaweicloud.com/ed/fa/546e1d3890f8a33d24afd63ee371fbb27e63abfde7cf350f06c975aba67afd95.png' },
  //   { key: 'style', value: 'position:absolute;left:-1000px;top:-1000px' },
  //   { key: 'alt', value: 'favicon' }]);

  const docFrag = document.createDocumentFragment(); // 创建文档碎片
  const createMetaTag = () => {
    const head = document.head;
    const listData: Array<Node> = [OgTitle, OgType, OgUrl, ogWidth, ogHeight];
    !sizeStore.isMobile.value && listData.push(canonical); // PC状态下head部分 增加canonical
    listData.map((ele) => {
      docFrag.appendChild(ele);
    });
    head.appendChild(docFrag);
    // const app = document.querySelector('#app');
    // if (app && app?.parentNode) {
    //   app.parentNode.insertBefore(img, app);
    // }
  };

  const modifiedOgTitle = (ogTitle: string) => {
    Document.querySelector('meta[property="og:title"]')?.setAttribute('content', ogTitle || `${currentSiteName()} - 全球开发者的开源社区,开源代码托管平台`);
  };
  const modifiedOgUrl = (pageUrl: string) => {
    Document.querySelector('meta[property="og:url"]')?.setAttribute('content', pageUrl || window.location.href);
  };
  const modifiedOgCanonical = (pageUrl: string) => {
    Document.querySelector('link[rel="canonical"]')?.setAttribute('href', pageUrl || window.location.href);
  };
  const modifiedOgType = (ogType: string) => {
    Document.querySelector('meta[property="og:type"]')?.setAttribute('content', ogType || 'project');
  };
  const modifiedOgImage = (imageUrl: string) => {
    Document.querySelector('meta[property="og:image"]')?.setAttribute('content', imageUrl || 'https://gitcode-img.obs.cn-south-1.myhuaweicloud.com/ed/fa/546e1d3890f8a33d24afd63ee371fbb27e63abfde7cf350f06c975aba67afd95.png');
  };

  return {
    createMetaTag,
    modifiedOgTitle,
    modifiedOgUrl,
    modifiedOgType,
    modifiedOgImage,
    modifiedOgCanonical
  };
};

